import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../shared/services//http/auth/auth.service';
import { UtilService } from '../shared/services/util/util.service';
import { ClientService } from '../shared/services/client.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router, private utilService:UtilService, private clientService:ClientService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    //   if (!this.authService.getToken()) {
    //   this.authService.showSuccessMessage({
    //     message: "Please Login First"
    //   })
    //   this.router.navigate(['/auth/login']);
    //   return false;
    // } else {
    //   return true;
    // }
    const requiredRole = route.data['role'];

    // Get client from URL
    const client = this.clientService.getClientFromUrl();
      
    if (!this.authService.getToken()) {
      // If the user is not logged in, navigate to login page
      // this.authService.showSuccessMessage({ message: "Please Login First" });
      this.utilService.showWarningSnackbar({
        msg: "Please Login First"
      });
      // this.router.navigate(['/auth/login']);
      this.router.navigate([client, 'auth', 'login']);
      
      return false;
    }

    // Validate client matches stored client
    const storedClient = this.clientService.getCurrentClient();
    if (client && storedClient && client !== storedClient) {
      // Client mismatch - log user out
      // this.utilService.showErrorDialog({
      //   msg: 'You are not authorized to access this client. You have been logged out.'
      // });
      this.logout();
      return false;
    }

    let currentUser = this.authService.getDataFromLocalStorage('user_details');
    currentUser = JSON.parse(currentUser);

    // If the user is logged in and has the correct role
    if (currentUser && currentUser.type == requiredRole) {
      return true;
    }

    // If the user is logged in but doesn't have the correct role, redirect to login page or another appropriate page
    // this.router.navigate(['/auth/login']);
    this.logout();

    return false;
  }

  private logout(): void {
    localStorage.clear();
    this.clientService.clearClient();
    this.router.navigate(['/']);
  }

}